import { __extends, __read, __spread } from "tslib";
import * as React from 'react';
import * as classNames from 'classnames';
import { isEqual } from 'lodash';
import { Wix } from '@wix/js-sdk-provider';
import ReactResizeDetector from 'react-resize-detector';
import { ArrowIcon } from './ArrowIcon';
import { getInstance as getI18Instance, setupI18n } from '../../services/i18n';
import { Badge } from '../Badge';
import './badge-list.scss';
var i18n = getI18Instance();
var DEFAULT_LANGUAGE = 'en';
var marginBottom = 4;
var PRIMARY_COLOR = 'color-5';
var BadgeList = /** @class */ (function (_super) {
    __extends(BadgeList, _super);
    function BadgeList(props) {
        var _this = _super.call(this, props) || this;
        _this.siteColors = _this.props.siteColors;
        _this.setWrapperRef = function (element) {
            _this.wrapperRef = element;
        };
        _this.setRemainderRef = function (element) {
            _this.remainderRef = element;
        };
        _this.getBadgeHeight = function () {
            var ref = _this.wrapperRef;
            if (ref) {
                var firstChild = ref.childNodes[0];
                if (!firstChild) {
                    return 0;
                }
                var badgeHeight = firstChild.scrollHeight;
                var margin = parseInt(window.getComputedStyle(firstChild).getPropertyValue('margin-bottom'));
                return badgeHeight + margin;
            }
            return 0;
        };
        _this.getColor = function (colorName) {
            return _this.siteColors && _this.siteColors.find(function (color) { return color.reference === colorName; })
                ? _this.siteColors.find(function (color) { return color.reference === colorName; }).value
                : 'black';
        };
        _this.getRemainderColor = function () {
            return _this.props.remainderColor || _this.getColor(PRIMARY_COLOR);
        };
        _this.filterBadges = function () {
            var maxRows = _this.props.maxRows;
            var ref = _this.wrapperRef;
            if (ref) {
                ref.removeChild(_this.remainderRef);
                ref.childNodes.length;
                var tops_1 = [];
                for (var i = 0; i < ref.childNodes.length; i++) {
                    var child = ref.childNodes[i];
                    tops_1.push(child.offsetTop);
                }
                var uniqueTops = __spread(new Set(tops_1));
                var maxRowsReached = uniqueTops[maxRows - 1] === undefined;
                var finalTop_1 = maxRowsReached ? uniqueTops[uniqueTops.length - 1] : uniqueTops[maxRows - 1];
                var wrapperHeight_1 = finalTop_1 + _this.getBadgeHeight() - marginBottom;
                var remainder_1 = tops_1.filter(function (top) { return top > finalTop_1; }).length;
                var lastChild = ref.childNodes[tops_1.length - remainder_1];
                ref.insertBefore(_this.remainderRef, lastChild);
                var checkRemainder_1 = function (i) {
                    if (_this.remainderRef.offsetTop >= wrapperHeight_1 && i < tops_1.length) {
                        ref.removeChild(_this.remainderRef);
                        var prevChild_1 = ref.childNodes[tops_1.length - remainder_1 - i];
                        remainder_1++;
                        _this.setState({ remainder: remainder_1 }, function () {
                            ref.insertBefore(_this.remainderRef, prevChild_1);
                            checkRemainder_1(i + 1);
                        });
                    }
                };
                _this.setState({ wrapperHeight: wrapperHeight_1, remainder: remainder_1 }, function () { return checkRemainder_1(1); });
            }
        };
        _this.renderRemainder = function () {
            var _a = _this.props, borderRadius = _a.borderRadius, layout = _a.layout, size = _a.size, font = _a.font, useTextRemainder = _a.useTextRemainder, onClickMore = _a.onClickMore, background = _a.background;
            var cursorClass = onClickMore ? 'pointer' : '';
            var borderClass = background ? '' : 'no-border';
            var backgroundClass = background ? '' : 'no-background';
            var remainderClass = classNames('remainder', layout, size, backgroundClass, cursorClass, borderClass);
            var color = _this.getRemainderColor();
            if (_this.state.remainder > 0 && !useTextRemainder) {
                return (React.createElement("div", { onClick: onClickMore, className: remainderClass, style: { borderRadius: borderRadius, color: color, borderColor: color, fontFamily: font } },
                    "+",
                    _this.state.remainder));
            }
            return React.createElement("div", null);
        };
        setupI18n(props.language || DEFAULT_LANGUAGE);
        _this.state = {
            wrapperHeight: 0,
            remainder: 4,
            filteredBadges: props.badges,
        };
        return _this;
    }
    BadgeList.prototype.componentDidMount = function () {
        var _this = this;
        this.filterBadges();
        if (!this.props.siteColors) {
            this.siteColors = Wix.Styles.getSiteColors();
            Wix.addEventListener(Wix.Events.STYLE_PARAMS_CHANGE, function () {
                _this.siteColors = Wix.Styles.getSiteColors();
                _this.filterBadges();
            });
        }
    };
    BadgeList.prototype.componentDidUpdate = function (prev) {
        if (isEqual(this.props, prev)) {
            return;
        }
        this.filterBadges();
    };
    BadgeList.prototype.render = function () {
        var _this = this;
        var _a = this.props, badges = _a.badges, layout = _a.layout, size = _a.size, borderRadius = _a.borderRadius, font = _a.font, background = _a.background, align = _a.align, useTextRemainder = _a.useTextRemainder, onClickMore = _a.onClickMore, hideDefaultIcon = _a.hideDefaultIcon;
        var backgroundClass = background ? '' : 'no-background';
        var wrapperClass = classNames('badge-list-wrapper', layout, size, align, backgroundClass);
        var color = this.getRemainderColor();
        return (React.createElement(ReactResizeDetector, { handleWidth: true, handleHeight: true, onResize: this.filterBadges }, function () { return (React.createElement("div", { className: "members-badge-list-lib-style-wrapper" },
            React.createElement("div", { className: wrapperClass, ref: _this.setWrapperRef, style: { height: _this.state.wrapperHeight } },
                badges.map(function (badge) { return (React.createElement(Badge, { key: badge.id, badge: badge, layout: layout, size: size, borderRadius: borderRadius, font: font, background: background, onLoadIcon: _this.filterBadges, onClick: _this.props.onBadgeClick, hideDefaultIcon: hideDefaultIcon })); }),
                React.createElement("span", { ref: _this.setRemainderRef }, _this.renderRemainder())),
            useTextRemainder && _this.state.remainder > 0 && !!onClickMore && (React.createElement("div", { className: 'textRemainderWrapper' },
                React.createElement("span", { onClick: onClickMore, style: { fontFamily: font, color: color } },
                    React.createElement("span", null, i18n.t('view_all_badges')),
                    React.createElement(ArrowIcon, null)))))); }));
    };
    return BadgeList;
}(React.Component));
export { BadgeList };
//# sourceMappingURL=BadgeList.js.map